<template>
  <div class="app-container">
    <transition name="el-zoom-in-top">
      <el-card v-show="!editStatus" class="custom-card filter-container mb-20" shadow="never">
        <el-input
          :placeholder="$t('table.loginNo')"
          v-model="listQuery.userNameOrLoginNo"
          style="width: 200px;"
          class="filter-item"
          @keyup.enter.native="handleFilter"
        />
        <el-select
          v-model="listQuery.roleId"
          :placeholder="$t('table.role')"
          clearable
          class="filter-item"
          style="width: 130px"
          @change="handleChange"
        >
          <el-option
            v-for="item in roleInfoList"
            :key="item.RoleId"
            :label="item.RoleName"
            :value="item.RoleId"
          />
        </el-select>
        <el-button
          v-waves
          round
          class="filter-item"
          type="primary"
          icon="el-icon-search"
          @click="handleFilter"
        >{{ $t("table.search") }}</el-button>
        <el-button
          v-if="roleId === 1"
          round
          class="filter-item"
          type="danger"
          icon="el-icon-circle-plus-outline"
          @click="handleCreate"
        >{{ $t("table.add") }}</el-button>
      </el-card>
    </transition>
    <transition name="el-zoom-in-top">
      <div v-show="!editStatus" class="filter-container">
        <el-table
          v-loading="listLoading"
          :key="tableKey"
          :data="list"

          fit
          stripe
          highlight-current-row
          style="width: 100%;"
        >
          <el-table-column :label="$t('table.id')" align="center" width="50px">
            <template slot-scope="scope">
              <span>{{ (scope.$index + 1) + ((listQuery.pageIndex - 1) * listQuery.pageSize) }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.loginNo')" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.LoginNo">{{ scope.row.LoginNo }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.userName')" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.UserName">{{ scope.row.UserName }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column label="今日订单数量" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="handleOrder(scope.row.UserId)">{{ scope.row.OrderDayNum }}</el-button>
            </template>
          </el-table-column>
          <el-table-column label="总订单数量" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="handleOrder(scope.row.UserId)">{{ scope.row.OrderSumNum }}</el-button>
            </template>
          </el-table-column>
          <!-- <el-table-column label="已使用次数" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.CurrentUseCount || 0 }}</span>
            </template>
          </el-table-column> -->
          <!-- <el-table-column label="最大使用次数" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.MaxUseCount">{{ scope.row.MaxUseCount }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column> -->
          <el-table-column :label="$t('table.sex')" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.SexNo">{{ scope.row.SexNo | sexFilter }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.role')" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.RoleId">{{ scope.row.RoleId | filterUserManage }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.status')" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.StatusNo">{{ scope.row.StatusNo | PgStatusNoFilter }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="roleId === 1"
            :label="$t('table.actions')"
            align="center"
            min-width="100%"
            class-name="small-padding fixed-width"
          >
            <template slot-scope="scope">
              <el-link
                v-if="calcPermission(permition, 2)"
                class="custom-link"
                size="small"
                type="primary"
                @click="handleUpdate(scope.row)"
              >{{ $t("table.edit") }}</el-link>
              <!-- <el-link
                v-if="calcPermission(permition, 3) && (scope.row.RoleId === 2 || scope.row.RoleId === 3)"
                class="custom-link"
                size="small"
                type="primary"
                @click="setWithdraw(scope.row)"
              >
                设置提现方式
              </el-link> -->
              <el-link
                v-if="scope.row.OpenId && calcPermission(permition, 3) && (scope.row.RoleId === 2 || scope.row.RoleId === 3)"
                class="custom-link"
                size="small"
                type="primary"
                @click="clearOpenid(scope.row.UserId)"
              >
                清除绑定账号
              </el-link>
              <!-- <el-link
                v-if="calcPermission(permition, 3)"
                class="custom-link"
                size="small"
                type="primary"
                @click="editUseCount(scope.row)"
              >
                修改最大使用次数
              </el-link> -->
              <el-link
                v-if="calcPermission(permition, 3)"
                class="custom-link"
                size="small"
                type="danger"
                @click="resetPwd(scope.row)"
              >重置账号密码</el-link>
              <el-link
                v-if="calcPermission(permition, 3) && scope.row.RoleInfo.RoleId === 3"
                class="custom-link"
                size="small"
                type="danger"
                @click="resetFieldPwd(scope.row)"
              >重置场地密码</el-link>
              <el-link
                v-if="calcPermission(permition, 2) && scope.row.LoginNo !== 'Admin'"
                class="custom-link"
                size="small"
                type="danger"
                @click="del(scope.row)"
              >删除</el-link>
            </template>
          </el-table-column>
        </el-table>
        <el-card class="custom-card" shadow="never">
          <el-pagination
            v-show="total > 0"
            :current-page="listQuery.pageIndex"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="listQuery.pageSize"
            :total="total"
            layout="total, prev, pager, next"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </el-card>
      </div>
    </transition>
    <!-- 编辑/新增 -->
    <transition name="el-zoom-in-bottom">
      <div v-show="editStatus" class="filter-container">
        <el-card class="custom-card" shadow="never">
          <el-row :gutter="10">
            <el-row class="CommitForm">
              <el-form
                v-if="commitFrom"
                ref="commitFrom"
                :rules="rules"
                :model="commitFrom"
                label-position="right"
                label-width="100px"
              >
                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                  <el-form-item :label="$t('table.loginNo')" prop="LoginNo">
                    <el-input v-model="commitFrom.LoginNo" :disabled="!flag && commitFrom.RoleId === 4" class="filter-item" placeholder="请输入登录账号"/>
                  </el-form-item>
                  <el-form-item v-if="flag" :label="$t('table.password')" prop="Password">
                    <el-input v-model="commitFrom.Password" class="filter-item" type="password" show-password placeholder="请输入登录密码"/>
                  </el-form-item>
                  <el-form-item :label="$t('table.telPhone')" prop="TelPhone">
                    <el-input v-model="commitFrom.TelPhone" class="filter-item" placeholder="请输入手机号"/>
                  </el-form-item>
                  <el-form-item :label="$t('table.userName')" prop="UserName">
                    <el-input v-model="commitFrom.UserName" class="filter-item" placeholder="请输入用户名"/>
                  </el-form-item>
                  <el-form-item :label="$t('table.role')" prop="RoleId">
                    <el-select
                      v-model="commitFrom.RoleId"
                      :placeholder="$t('table.role')"
                      :disabled="!flag"
                      clearable
                      class="filter-item"
                      style="width: 130px"
                    >
                      <el-option
                        v-for="item in roleList"
                        :key="item.RoleId"
                        :label="item.RoleName"
                        :value="item.RoleId"
                      />
                    </el-select>
                  </el-form-item>
                  <el-form-item v-if="commitFrom.RoleId === 2 || commitFrom.RoleId === 3" :label="`提现手续费`" prop="Poundage">
                    <el-input v-model="commitFrom.Poundage" class="filter-item" placeholder="提现手续费"/>
                  </el-form-item>
                  <el-form-item :label="$t('table.status')" prop="StatusNo">
                    <el-select v-model="commitFrom.StatusNo" class="filter-item" placeholder="请选择状态">
                      <el-option
                        v-for="item in calendarTypeOptions"
                        :key="item.key"
                        :label="item.display_name"
                        :value="item.key"
                      />
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('table.sex')">
                    <el-select v-model="commitFrom.SexNo" class="filter-item" placeholder="请选择性别">
                      <el-option
                        v-for="item in calendarTypeOptions1"
                        :key="item.key"
                        :label="item.display_name"
                        :value="item.key"
                      />
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('table.email')">
                    <el-input v-model="commitFrom.Email" class="filter-item" placeholder="请输入邮箱"/>
                  </el-form-item>
                </el-col>
                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                  <el-form-item :label="$t('table.birthDay')">
                    <div class="filter-item">
                      <el-date-picker v-model="commitFrom.BirthDay" type="date" placeholder="选择日期"/>
                    </div>
                  </el-form-item>
                  <el-form-item :label="$t('table.address')">
                    <el-input v-model="commitFrom.Address" class="filter-item" placeholder="请输入地址"/>
                  </el-form-item>
                  <el-form-item :label="$t('table.idCard')">
                    <el-input v-model="commitFrom.IdCard" class="filter-item" placeholder="请输入身份证号"/>
                  </el-form-item>
                  <el-form-item :label="$t('table.realName')">
                    <el-input v-model="commitFrom.RealName" class="filter-item" placeholder="请输入真实姓名"/>
                  </el-form-item>
                  <el-form-item :label="$t('table.avatar')">
                    <el-upload
                      :action="urlAction"
                      :show-file-list="false"
                      :on-success="handleAvatarSuccess"
                      :before-upload="beforeAvatarUpload"
                      class="avatar-uploader"
                      list-type="picture"
                    >
                      <img v-if="commitFrom.Avatar" :src="baseUrl + commitFrom.Avatar" class="avatar">
                      <i v-else class="el-icon-plus avatar-uploader-icon"/>
                    </el-upload>
                  </el-form-item>
                </el-col>
              </el-form>
            </el-row>
          </el-row>
          <el-button
            style="margin-left: 60px"
            round
            class="filter-item"
            type="info"
            @click="cancelCommit"
          >{{ $t("table.cancel") }}</el-button>
          <el-button
            v-if="calcPermission(permition, 4)"
            round
            class="filter-item"
            type="primary"
            @click="commitEdit('commitFrom')"
          >{{ $t("table.submit") }}</el-button>
        </el-card>

      </div>
    </transition>
    <editpwd ref="mychild" :date="edituser"/>

    <!-- 设置提现方式 -->
    <dialog-custom
      :centerDialogVisible="centerDialogVisible"
      :footer="false"
      title="设置提现方式"
      @handleCancel="cancel"
    >
      <el-form ref="withdrawForm" :model="withdrawForm" :rules="withdrawRules" label-width="140px" class="demo-withdrawForm">
        <el-form-item label="提现方式">
          <el-radio-group v-model="withdrawForm.WithDrawWay">
            <el-radio-button :label="0">手动</el-radio-button>
            <el-radio-button :label="1">自动</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <template v-if="withdrawForm.WithDrawWay === 1">
          <el-form-item label="提现时间" prop="WithDrawTime">
            <el-radio-group v-model="withdrawForm.WithDrawTime">
              <el-radio :label="1">日结</el-radio>
              <el-radio :label="2">月结</el-radio>
            </el-radio-group>
            <el-link :underline="false" type="danger">(每天凌晨5点结算)</el-link>
          </el-form-item>
          <el-form-item v-if="withdrawForm.WithDrawTime === 2" label="月结日期" prop="CashDay">
            <el-input v-model="withdrawForm.CashDay" placeholder="月结日期"/>
          </el-form-item>
          <el-form-item label="提现账户" prop="WithDrawAccount">
            <el-select v-model="withdrawForm.WithDrawAccount" placeholder="请选择">
              <el-option
                label="微信"
                value="WxMin"/>
              <el-option
                label="银行卡"
                value="Bank"/>
            </el-select>
            <el-link :underline="false" type="danger">
              代理商需登录小程序绑定账号
            </el-link>
          </el-form-item>

          <el-form-item label="每天最大提现金额" prop="MaxWithDraw">
            <el-input v-model="withdrawForm.MaxWithDraw" placeholder="微信提现最大值5000，银行卡提现最大值20000"/>
            <div>
              <el-link :underline="false" type="danger">最小提现金额为10，不填写为当前余额</el-link>
            </div>
          </el-form-item>
          <template v-if="withdrawForm.WithDrawAccount === 'Bank'">
            <el-form-item label="收款方银行卡号" prop="BankNo">
              <el-input v-model="withdrawForm.BankNo" placeholder="收款方银行卡号"/>
            </el-form-item>
            <el-form-item label="收款方用户名" prop="TrueName">
              <el-input v-model="withdrawForm.TrueName" placeholder="收款方用户名"/>
            </el-form-item>
            <el-form-item label="开户行" prop="BankCode">
              <el-select v-model="withdrawForm.BankCode" placeholder="请选择">
                <el-option
                  v-for="(item, index) in bankInfo"
                  :key="index"
                  :label="item.label"
                  :value="item.value"/>
              </el-select>
            </el-form-item>
          </template>

        </template>
        <el-form-item>
          <el-button type="primary" @click="submitWithdrawForm('withdrawForm')">提交</el-button>
        </el-form-item>
      </el-form>
    </dialog-custom>

    <!-- 修改最大使用次数 -->
    <create-form
      v-if="visible"
      ref="createModal"
      @close="visible = false"
      @refresh="getList()"
    />
  </div>
</template>
<script>
import DialogCustom from '@/components/DialogCustom'
import CreateForm from './components/MaxCreateForm.vue'
import { qryUser, addUser, modUser, updateFieldUserDevPassword, setWithDrawWay, clearUserOpenId, delUser } from '@/api/user'
import { getBankInfo } from '@/api/account'
import { qryRoleInfo } from '@/api/baseModule'
import editpwd from '@/views/userManages/editpwd'
import md5 from 'js-md5'
import waves from '@/directive/waves' // 水波纹指令
const calendarTypeOptions = [
  { key: 'A', display_name: '启用' },
  { key: 'S', display_name: '禁用' }
]
const calendarTypeOptions1 = [
  { key: 'M', display_name: '男' },
  { key: 'F', display_name: '女' }
]
const calendarTypeKeyValue = calendarTypeOptions.reduce((acc, cur) => {
  acc[cur.key] = cur.display_name
  return acc
}, {})
const calendarTypeKeyValue1 = calendarTypeOptions1.reduce((acc, cur) => {
  acc[cur.key] = cur.display_name
  return acc
}, {})
export default {
  name: 'UserManage',
  directives: {
    waves
  },
  filters: {
    PgStatusNoFilter(type) {
      return calendarTypeKeyValue[type]
    },
    sexFilter(type) {
      return calendarTypeKeyValue1[type]
    },
    filterUserManage(value) {
      let str = ''
      switch (value) {
        case 1:
          str = '管理员'
          break
        case 2:
          str = '代理商'
          break
        case 3:
          str = '场地方'
          break
        case 4:
          str = '用户'
          break
        case 5:
          str = '维护人员'
          break
      }
      return str
    }
  },
  components: { editpwd, DialogCustom, CreateForm },
  data() {
    const self = this
    var judgeDecimals = (rule, value, callback) => {
      if (/^0\.?\d{0,2}$/.test(value)) {
        callback()
      } else {
        callback(new Error('请输入0-1的小数，不包含1'))
      }
    }
    const date1 = (rule, value, callback) => {
      if (value >= 1 && value <= 31) {
        callback()
      } else {
        callback('请输入1-31的数字')
      }
    }
    const betweenNumber = (rule, value, callback) => {
      console.log(self)
      if (self.withdrawForm.WithDrawAccount === 'WxMin') {
        if ((/^\d+/.test(value) && value <= 5000 && value >= 10) || !value) {
          callback()
        } else {
          callback('最大提现金额为5000, 最小提现金额为10')
        }
      } else if (self.withdrawForm.WithDrawAccount === 'Bank') {
        if ((/^\d+/.test(value) && value <= 20000 && value >= 10) || !value) {
          callback()
        } else {
          callback('最大提现金额为20000，最小提现金额为10')
        }
      }
    }
    return {
      visible: false,
      bankInfo: [],
      withdrawForm: {
        UserId: 0,
        WithDrawWay: 1,
        WithDrawTime: 1,
        CashDay: 1,
        WithDrawAccount: 'WxMin',
        MaxWithDraw: 5000,
        BankNo: null,
        TrueName: null,
        BankType: null,
        BankCode: null
      },
      withdrawRules: {
        WithDrawAccount: [
          { required: true, message: '请选择提现账户' }
        ],
        CashDay: [
          { required: true, message: '请输入月结日期' },
          { validator: date1, trigger: 'blur' }
        ],
        BankNo: [
          { required: true, message: '请输入收款方银行卡号', pattern: /^\d+$/ }
        ],
        TrueName: [
          { required: true, message: '请输入收款方用户名' }
        ],
        BankCode: [
          { required: true, message: '请选择开户行' }
        ],
        WithDrawTime: [
          { required: true, message: '请选择提现时间', pattern: /^(1|2)$/ }
        ],
        MaxWithDraw: [
          { required: false, message: '请输入最大提现金额' },
          { validator: betweenNumber, trigger: 'blur' }
        ]
      },
      centerDialogVisible: false,
      edituser: {
        userId: '',
        pwd: '',
        editshow: false
      },
      editStatus: false,
      list: null,
      total: null,
      flag: false,
      listLoading: true,
      tableKey: 0,
      listQuery: {
        pageIndex: 1,
        pageSize: 10,
        roleId: null,
        userNameOrLoginNo: null
      },
      imageUrl: '',
      roleList: [],
      calendarTypeOptions,
      calendarTypeOptions1,
      baseUrl: process.env.BASE_API,
      urlAction: process.env.BASE_API + '/api/common/uploadImg',
      commitFrom: {
        UserId: 0,
        LoginNo: '',
        Password: '',
        TelPhone: '',
        UserName: '',
        RoleId: null,
        BirthDay: '',
        SexNo: '',
        Address: '',
        Email: '',
        Avatar: '',
        IdCard: '',
        StatusNo: '',
        RealName: '',
        Poundage: 0
      },
      rules: {
        LoginNo: [
          { required: true, message: '请输入登录账号', trigger: 'blur' },
          { min: 1, max: 32, message: '长度在 1 到 32 个字符', trigger: 'blur' }
        ],
        Password: [
          { required: true, message: '请输入登录密码', trigger: 'blur' }
        ],
        UserName: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
        ],
        TelPhone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { min: 1, max: 18, message: '长度在 1 到 18 个字符', trigger: 'blur' }
        ],
        RoleId: [{ required: true, message: '请选择角色', trigger: 'blur' }],
        StatusNo: [{ required: true, message: '请选择状态', trigger: 'blur' }],
        Poundage: [
          { required: true, message: '请输入提现手续费', trigger: 'blur' },
          { validator: judgeDecimals, trigger: 'blur' }
        ]
      },
      permition: 0,
      roleId: 0,
      roleInfoList: []
    }
  },
  watch: {
    'withdrawForm.BankCode': {
      handler(value) {
        if (value) {
          this.withdrawForm.BankType = this.bankInfo.filter(item => item.value === value)[0].label
        } else {
          this.withdrawForm.BankType = null
        }
      }
    }
  },
  created() {
    // if (this.$store.state.roleInfo) {
    //   this.$store.state.roleInfo.LsList[0].RolePrograms.forEach(item => {
    //     if (this.$route.path === item.ProgramInfo.PgUrl) {
    //       this.permition = item.Permition
    //       this.getList()
    //       this.getRoleInfo()
    //     }
    //   })
    // } else {
    //   qryRoleInfo().then(response => {
    //     this.$store.state.roleInfo = response
    //     response.LsList[0].RolePrograms.forEach(item => {
    //       if (this.$route.path === item.ProgramInfo.PgUrl) {
    //         this.permition = item.Permition
    //         this.getList()
    //         this.getRoleInfo()
    //       }
    //     })
    //   })
    // }
    this.roleId = this.$store.getters.roles.RoleId
    qryRoleInfo().then(response => {
      console.log(response, '582-------------------')
      this.$store.state.roleInfo = response
      this.roleInfoList = response.LsList
      response.LsList[0].RolePrograms.forEach(item => {
        if (this.$route.path === item.ProgramInfo.PgUrl) {
          this.permition = item.Permition
          console.log(this.permition)
          this.getList()
          this.getRoleInfo()
        }
      })
    })
  },
  methods: {
    // 查看用户订单
    handleOrder(id) {
      this.$router.push({ path: '/orderList', query: { seetuserId: id }})
    },
    editUseCount(row) {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.createModal.init({ userId: row.UserId, maxUseCount: row.MaxUseCount })
      })
    },
    // 删除用户
    del(row) {
      delUser({ Id: row.UserId }).then(res => {
        if (res) {
          this.getList()
        }
      })
    },
    // 清理用户openid
    clearOpenid(Id) {
      clearUserOpenId({ Id }).then(res => {
        this.$message.success('清除成功')
        this.getList()
      })
    },
    // 提现方式提交
    submitWithdrawForm(dataForm) {
      this.$refs[dataForm].validate(valid => {
        if (valid) {
          setWithDrawWay(this.withdrawForm).then(res => {
            this.$message.success('成功')
            this.cancel()
            this.getList()
          })
        }
      })
    },
    // 取消提现方式弹窗
    cancel() {
      this.withdrawForm = {
        UserId: 0,
        WithDrawWay: 1,
        WithDrawTime: 1,
        CashDay: 1,
        WithDrawAccount: 'WxMin',
        MaxWithDraw: null,
        BankNo: null,
        TrueName: null,
        BankType: null,
        BankCode: null
      }
      this.$refs.withdrawForm.clearValidate()
      this.centerDialogVisible = false
    },
    // 设置提现方式
    async setWithdraw(row) {
      for (const key in this.withdrawForm) {
        this.withdrawForm[key] = row[key]
      }
      const res = await getBankInfo()
      this.bankInfo = JSON.parse(res).map(item => {
        return {
          value: item[Object.keys(item)],
          label: Object.keys(item)[0]
        }
      })
      this.centerDialogVisible = true
    },
    getList() {
      this.listLoading = true
      qryUser(this.listQuery).then(response => {
        this.list = response.LsList
        this.total = response.TotalRows
        this.listLoading = false
      })
    },
    // 切换选择
    handleChange() {
      if (this.listQuery.roleId === '') {
        this.listQuery.roleId = null
      }
    },
    getRoleInfo() {
      this.roleList = JSON.parse(JSON.stringify(this.$store.state.roleInfo.LsList))
      for (const iterator of this.roleList) {
        if (iterator.RoleId === 4) {
          this.roleList.splice(this.roleList.indexOf(iterator), 1)
          break
        }
      }
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.pageIndex = val
      this.getList()
    },
    handleFilter() {
      this.listQuery.pageIndex = 1
      this.getList()
    },
    handleCreate() {
      this.commitFrom = {
        UserId: 0,
        LoginNo: null,
        Password: null,
        TelPhone: null,
        UserName: null,
        RoleId: null,
        BirthDay: null,
        SexNo: null,
        Address: null,
        Email: null,
        Avatar: null,
        IdCard: null,
        StatusNo: null,
        RealName: null,
        Poundage: 0
      }
      this.editStatus = true
      this.flag = true
    },
    handleUpdate(row) {
      console.log(row)
      for (const key in this.commitFrom) {
        this.commitFrom[key] = row[key]
      }
      this.flag = false
      this.editStatus = true
    },
    commitEdit(formName) {
      this.$refs[formName].validate(valid => {
        this.commitFrom['Password'] = this.flag ? md5(this.commitFrom['Password']) : this.commitFrom['Password']
        if (valid) {
          console.log(this.commitFrom.RoleId)
          if (this.commitFrom.RoleId !== 2 && this.commitFrom.RoleId !== 3) {
            this.commitFrom.Poundage = 0
          }
          console.log(this.commitFrom.Poundage)
          if (this.commitFrom.UserId > 0) {
            modUser(this.commitFrom).then(response => {
              if (response) {
                this.getList()
                this.commitFrom.Avatar = ''
                this.editStatus = false
                this.$message({
                  type: 'success',
                  message: '修改成功'
                })
              }
            })
          } else {
            addUser(this.commitFrom).then(response => {
              if (response) {
                this.getList()
                this.commitFrom.Avatar = ' '
                this.editStatus = false
                this.$message({
                  type: 'success',
                  message: '添加成功'
                })
              }
            })
          }
        } else {
          this.$message.error('请检查输入内容是否符合条件')
          return false
        }
      })
    },
    // 重置场地密码
    resetFieldPwd(row) {
      this.$prompt('请输入场地密码', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^\w{6,}$/,
        inputErrorMessage: '场地密码格式不正确, 密码长度最少6位',
        inputPlaceholder: '请输入需要重置的场地设备登录密码'
      }).then(({ value }) => {
        updateFieldUserDevPassword({ userId: row.UserId, devPwd: value }).then(res => {
          if (res) {
            this.$notify({
              type: 'success',
              title: '成功',
              message: '场地设备登录密码修改成功'
            })
            this.getList()
          }
        })
      }).catch(() => {})
    },
    resetPwd(id) {
      this.edituser = id
      this.$refs.mychild.openedit()
    },
    handleAvatarSuccess(response, file, fileList) {
      console.log(response.Data)
      this.commitFrom.Avatar = response.Data
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isLt2M
    },
    cancelCommit() {
      // this.commitFrom = {
      //   UserId: 0,
      //   LoginNo: null,
      //   TelPhone: null,
      //   UserName: null,
      //   RoleId: null,
      //   BirthDay: null,
      //   SexNo: null,
      //   Address: null,
      //   Email: null,
      //   Avatar: null,
      //   IdCard: null,
      //   StatusNo: null,
      //   RealName: null
      // }
      this.editStatus = false
    }
  }
}
</script>
<style>
.el-form-item__label{
  float: left;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.el-form-item__label{
  float: left;
}
</style>
